import { render, staticRenderFns } from "./MailRequest.vue?vue&type=template&id=1736dffd&scoped=true&"
import script from "./MailRequest.vue?vue&type=script&lang=js&"
export * from "./MailRequest.vue?vue&type=script&lang=js&"
import style0 from "./MailRequest.vue?vue&type=style&index=0&id=1736dffd&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1736dffd",
  null
  
)

export default component.exports